import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { services } from "../mock";

const Services = () => {
  return (
    <div>
      {/* Header */}
      <section className="relative bg-gradient-to-b from-teal-50/70 to-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-24 text-center">
          <span className="inline-block bg-teal-100 text-teal-800 text-xs font-bold tracking-[0.12em] px-4 py-2 rounded-full">
            WHAT WE OFFER
          </span>
          <h1 className="mt-6 text-5xl font-extrabold tracking-tight text-slate-900">
            Our Services
          </h1>
          <p className="mt-5 text-lg text-slate-500 max-w-2xl mx-auto leading-relaxed">
            Focused, end-to-end consulting solutions designed to help your
            business trade, partner, and grow across global markets.
          </p>
        </div>
      </section>

      {/* Services list */}
      <section className="py-16 lg:py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-8 space-y-8">
          {services.map((service, idx) => {
            const Icon = service.icon;
            return (
              <div
                key={service.id}
                className="grid md:grid-cols-3 gap-8 bg-white border border-slate-100 rounded-2xl p-8 lg:p-10 transition-all duration-300 hover:shadow-xl hover:shadow-slate-200/50"
              >
                <div className="md:col-span-2">
                  <div className="flex items-center gap-4">
                    <div className="flex items-center justify-center w-14 h-14 rounded-xl bg-teal-50 text-teal-600 shrink-0">
                      <Icon className="w-7 h-7" strokeWidth={1.8} />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-900">
                      {service.title}
                    </h2>
                  </div>
                  <p className="mt-5 text-[15px] text-slate-500 leading-relaxed">
                    {service.description}
                  </p>
                </div>
                <div className="md:border-l md:border-slate-100 md:pl-8">
                  <ul className="space-y-3">
                    {service.features.map((f) => (
                      <li key={f} className="flex items-start gap-3">
                        <span className="mt-0.5 flex items-center justify-center w-5 h-5 rounded-full bg-teal-100 text-teal-700 shrink-0">
                          <Check className="w-3 h-3" strokeWidth={3} />
                        </span>
                        <span className="text-sm text-slate-600">{f}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* CTA */}
      <section className="bg-slate-50 border-t border-slate-100">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 py-20 text-center">
          <h2 className="text-3xl font-extrabold text-slate-900 tracking-tight">
            Not sure which service fits your goals?
          </h2>
          <p className="mt-4 text-lg text-slate-500">
            Reach out and our team will help you map the right path to global
            growth.
          </p>
          <Link
            to="/contact"
            className="mt-8 inline-flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white font-semibold px-8 py-3.5 rounded-full transition-all duration-200 hover:shadow-lg hover:shadow-teal-600/25 active:scale-95"
          >
            Contact Us <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Services;
